import type { Updater } from '@tanstack/vue-table'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { Ref } from 'vue'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function valueUpdater<T extends Updater<any>>(updaterOrValue: T, ref: Ref) {
  ref.value
    = typeof updaterOrValue === 'function'
      ? updaterOrValue(ref.value)
      : updaterOrValue
}

export function formatPhoneNumber(phoneNumber: string) {
  if (phoneNumber.startsWith('+')) {
      phoneNumber = phoneNumber.substring(1);
  }
  if (phoneNumber.startsWith('0')) {
      phoneNumber = '254' + phoneNumber.substring(1);
  }
  if (phoneNumber.match(/^(7|1)/)) {
      phoneNumber = '254' + phoneNumber;
  }
  return phoneNumber;
}

export function formatDataUnitSize(data: string) {
  const unit = data.slice(-1)
  const size = data.slice(0, -1)
  if(unit === 'G')
    return size + ' GB'
  else if(unit === 'M')
    return size + ' MB'
  else 
    return size + ' KB'
}


export function setCookie(name: string, value: string, days: number) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function getCookie(name: string) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}